var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.loading)?_c('div',{attrs:{"id":"app"}},[_c('v-app',{style:({
            background: `linear-gradient(to bottom, ${_vm.$ajustes.colorSuperior} 10%, ${_vm.$ajustes.colorInferior} ${_vm.$ajustes.colorDegradado * 25}%, ${_vm.$ajustes.colorInferior} 100%)`
          })},[_c('div',[(_vm.$route.path !== '/dashboard')?_c('navBar'):_vm._e(),_c('router-view',{attrs:{"desktop":_vm.desktop},on:{"endSplash":_vm.endSplash}})],1)]),(_vm.$route.path !== '/dashboard')?_c('footter'):_vm._e()],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }